import './index.css';
import { Typography, Space } from 'antd';

const { Text, Link, Title } = Typography;

function Footer(props) {
	return (
		<div className="footerContainer">
			{/* <Text>© PRIMULA HOTEL KUALA TERENGGAU. ALL RIGHTS RESERVED.</Text> */}
		</div>
	)
}

export default Footer;